import React from 'react'

function Hero() {
    return (
        <section className='hero'>
            <div className="container">
                <div className="hero-text">
                    <h1 className='hero-title'>
                        PRAGA STORE
                    </h1>
                    <h1 className="hero-subtitle">
                        Shoes Seller All Around EGYPT <br />
                        no branches
                    </h1>
                    <a href='#products' className="shop-now">Shop Now</a>
                </div>
            </div>
        </section>
    )
}

export default Hero